import React from 'react';

import { createClassName } from 'utils/createClassName';

import './authFormFooterLayoutStyles.css';

type Props = {
  axis?: 'x' | 'y';
};

export const AuthFormFooterLayoutComponent: React.FC<Props> = (props) => {
  const { children, axis = 'y' } = props;

  const createElementClassName = createClassName('authFormFooterLayout');

  return (
    <div className={createElementClassName('wrapper', { axis })}>
      {children}
    </div>
  );
};
